var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFileSpreadsheet = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.25 0C3.52065 0 2.82118 0.289731 2.30546 0.805456C1.78973 1.32118 1.5 2.02065 1.5 2.75V21.25C1.5 21.9793 1.78973 22.6788 2.30546 23.1945C2.82118 23.7103 3.52065 24 4.25 24H18.25C18.9793 24 19.6788 23.7103 20.1945 23.1945C20.7103 22.6788 21 21.9793 21 21.25V6.75C21 6.55109 20.921 6.36032 20.7803 6.21967L14.7803 0.21967C14.6397 0.0790176 14.4489 0 14.25 0H4.25ZM3.36612 1.86612C3.60054 1.6317 3.91848 1.5 4.25 1.5H13.5V6.74998C13.5 7.16419 13.8358 7.49998 14.25 7.49998H19.5V21.25C19.5 21.5815 19.3683 21.8994 19.1339 22.1339C18.8995 22.3683 18.5815 22.5 18.25 22.5H4.25C3.91848 22.5 3.60054 22.3683 3.36612 22.1339C3.1317 21.8994 3 21.5815 3 21.25V2.75C3 2.41848 3.1317 2.10054 3.36612 1.86612ZM18.4393 5.99998L15 2.56066V5.99998H18.4393Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.25 10.5C4.83579 10.5 4.5 10.8358 4.5 11.25V20.25C4.5 20.6642 4.83579 21 5.25 21H17.25C17.6642 21 18 20.6642 18 20.25V11.25C18 10.8358 17.6642 10.5 17.25 10.5H5.25ZM16.5 12H6V13.5H16.5V12ZM6 15H10.5V16.5H6V15ZM10.5 18H6V19.5H10.5V18ZM12 15H16.5V16.5H12V15ZM16.5 18H12V19.5H16.5V18Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFileSpreadsheet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file-spreadsheet.999b9532344778f887c8342b7842d40c.svg";